import { ReactNode } from 'react'
import { FormGroup, Modal } from 'react-bootstrap'
import FormHandler, { FormParams } from '../../../utils/Form/FormHandler'
import MultipleFileInputWidget from '../../../utils/Form/Widgets/MultipleFileInputWidget'
import Field from '../../../utils/Form/Widgets/Field'
import Check from '../../../utils/Form/Widgets/Check'

type Props = {
  onHide: () => void
  show: boolean
  refreshFunction?: Function
  itemIdForUpload: string
}

class DataRequests {
  company?: number
  data_period?: string
  energy_type?: string
  data_request_status?: string
  data_request_description?: string
  all_data_uploaded?: boolean
}

class DataRequestUploadFileModal extends FormHandler {
  // eslint-disable-next-line
  constructor(props: Props) {
    super(props)
    this.state = { entity: new DataRequests() }
  }

  getApiUrl(): string {
    return '/data_requests/apiDataRequestFileUpload'
  }
  getSingleUrl(): string | null {
    if (this.props.itemIdForUpload === 'add') {
      return null
    } else {
      return '/data_requests/single/' + this.props.itemIdForUpload
    }
  }

  getPostData(): object {
    return { entity: this.state.entity, data_request_id: this.props.itemIdForUpload }
  }

  render(): ReactNode {
    var state = this.state as any
    let title = 'Data Request File Upload'
    return (
      <Modal
        id='data_request_file_upload_modal'
        aria-hidden='true'
        dialogClassName='modal-dialog modal-dialog-centered'
        size='lg'
        show={this.props.show}
        backdrop={true}
        onHide={this.props.onHide}
      >
        <form
          onSubmit={(event) => {
            this.handleSubmit(event).then((response) => {
              if (this.props.refreshFunction) {
                this.props.refreshFunction(response.data)
              }
            })
          }}
        >
          <Modal.Header closeButton>
            <Modal.Title>{title}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <FormGroup>
              <Field
                title='Data Request Description'
                className='form-control'
                type='text'
                name='data_request_description'
                onInput={(event: any) => {
                  this.handleInputChange(event)
                }}
                defaultValue={state.entity.data_request_description}
              />
            </FormGroup>
            <FormGroup>
              <MultipleFileInputWidget
                fileUploadKeyUrl='/data_requests/getDataRequestFileUploadKey'
                name='data_request_files'
                fieldName='data_file'
                onChange={(event) => {
                  this.handleInputChange(event)
                }}
                accept='*'
                defaultFiles={state.entity.data_request_files} //data_request_files (reference id) data_files (file id)
              />
            </FormGroup>
            <FormGroup>
              <Check
                title='All Data Uploaded'
                name='all_data_uploaded'
                type='switch'
                checked={state.entity.all_data_uploaded ? true : false}
                options={['']}
                onChange={(event: any) => {
                  this.handleInputChange(event)
                }}
              />
            </FormGroup>
          </Modal.Body>
          <Modal.Footer className='justify-content-end'>
            <button type='submit' className='btn btn-success btn-sm'>
              Save Files
            </button>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }
}

export { DataRequestUploadFileModal }
